import React from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "moment/locale/hu";

interface MyLeaveCalendarPathFillAfterProps {
  color: string;
}

export const MyLeaveCalendarPathFillAfter = ({ color }: MyLeaveCalendarPathFillAfterProps) => {
  return (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="m 0.00152901,26.987165 0.407023,0.0059 C 1.746939,27.012585 3.026027,26.535666 3.941672,25.729465 l 10.790433,-9.5 c 1.747856,-1.5388 1.747856,-3.934 0,-5.4728 L 3.941672,1.2567007 C 3.026027,0.45050068 1.729744,0.03759568 0.40508801,0.01365468 l -0.4050969975,-0.0073 z"
      fill={color}
    />
  );
};

export default MyLeaveCalendarPathFillAfter;
